import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export type SyncOption = 'sync-online' | 'sync-offline' | 'discard' | 'cancel';

@Component({
	selector: 'bp-sync-options-modal',
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="modal-header">
			<h5 class="modal-title">Synchronisieren</h5>
			<button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.close('cancel')"></button>
		</div>
		<div class="modal-body">
			<p>Was möchten Sie tun?</p>
			<div class="d-grid gap-2">
				<button type="button" class="btn btn-primary" [disabled]="!networkOnline" (click)="activeModal.close('sync-online')"
					[title]="networkOnline ? '' : 'Keine Internetverbindung'">
					<i class="bi bi-cloud-upload me-2"></i>Synchronisieren & Online gehen
				</button>
				<button type="button" class="btn btn-outline-primary" [disabled]="!networkOnline" (click)="activeModal.close('sync-offline')"
					[title]="networkOnline ? '' : 'Keine Internetverbindung'">
					<i class="bi bi-arrow-repeat me-2"></i>Nur synchronisieren (offline bleiben)
				</button>
				<button type="button" class="btn btn-outline-danger" [disabled]="!networkOnline" (click)="activeModal.close('discard')"
					[title]="networkOnline ? '' : 'Keine Internetverbindung'">
					<i class="bi bi-trash me-2"></i>Änderungen verwerfen & Online gehen
				</button>
			</div>
			@if (!networkOnline) {
				<div class="alert alert-warning mt-3 mb-0">
					<i class="bi bi-wifi-off me-2"></i>Keine Internetverbindung verfügbar.
				</div>
			}
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="activeModal.close('cancel')">Abbrechen</button>
		</div>
	`,

})
export class SyncOptionsModalComponent {
	@Input() networkOnline = true;

	constructor(public activeModal: NgbActiveModal) {}
}
